<template>
    <div class="AuthLayout">
        <router-view />
    </div>
</template>
